import { AUD_APPS_ACTI312_RACCOON_WEDDING } from '../../constants/experiments';
import { TAppState } from '../../types/appState';
import { isExperimentActive } from '../../utils/getExperiment';
import { selectExperiments } from '../experiments';

export function isRacoonWeddingEnabledSelector(state: TAppState) {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, AUD_APPS_ACTI312_RACCOON_WEDDING, 'B');
}
